import { toast } from "react-toastify";
import { createSlice } from '@reduxjs/toolkit';
import {CommonService} from '../../services/CommonService';

import { APIResponse } from '../types/Common';
import { ConfigPanelService } from "@src/services/ConfigPanelService";


const configPanel = createSlice({
    name: 'configPanel',
    initialState: {
        bankList: [],
    },
    reducers: {
        setBankList: (state, action) => {
            state.bankList = action.payload;
        },
    },
});

export default configPanel.reducer;

const { setBankList } = configPanel.actions


export const getMasterConfig = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.getMasterConfig().then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                let data = response.data && response.data.data
                resolve(response.data)
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}
export const saveBankConfig = (params:any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.saveBankConfig(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                let data = response.data && response.data.data
                resolve(response.data)
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

export const getBankConfig = (params:any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.getBankConfig(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                let data = response.data && response.data.data
                resolve(response.data)
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}

export const getBankList = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.getBankList().then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                let data = response.data && response.data.data
                setBankList(data)
                resolve(response.data)
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}
export const deleteBankRow = (params:any) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        ConfigPanelService.deleteBankRow(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                let data = response.data && response.data.data
                resolve(response.data)
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}



